import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import Container from '@/components/atoms/Container'

export function Onboarding() {
	return (
		<div className='flex w-full pb-14'>
			<Container>
				<div className='flex flex-col gap-6 px-4'>
					<p className='text-zinc-50 text-2xl md:text-3xl leading-8 font-semibold w-full'>
						Comece sua jornada
					</p>

					<Swiper
						spaceBetween={12}
						slidesPerView={'auto'}
						className='!overflow-visible'
						simulateTouch={true}
						breakpoints={{
							1424: {
								simulateTouch: false,
							},
						}}
					>
						{[
							{
								label: 'Mapeie suas<br />habilidades',
								step: 'Faça o teste online',
							},
							{
								label: 'Devolutiva com<br />mentor',
								step: 'Agende sua sessão',
							},
							{
								label: 'Receba seu PDI<br />personalizado',
								step: 'Seu plano de carreira ideal',
							},
							{
								label: 'Comece os cursos<br />recomendados',
								step: 'Trilhas de estudo indicada',
							},
							{
								label: 'Mentorias com<br />especialistas',
								step: 'Agende suas sessões',
							},
							{
								label: 'Avalie o seu<br />progresso',
								step: 'Veja sua evolução',
							},
						].map((item, key) => (
							<SwiperSlide
								key={key}
								className='!w-auto flex flex-col gap-4 max-w-max items-center !opacity-100 cursor-pointer'
							>
								<div className='flex flex-col gap-4 max-w-max'>
									<div className='flex border border-white/20 items-center py-2 gap-3 px-3 rounded-[200px] min-w-[207px]'>
										<div className='min-w-8 w-8 min-h-8 bg-brand-fluency flex items-center justify-center rounded-full'>
											<span className='text-zinc-50'>{key + 1}</span>
										</div>
										<span
											className='text-sm text-zinc-50 font-semibold leading-[128%]'
											dangerouslySetInnerHTML={{ __html: item.label }}
										/>
									</div>
									<p className='text-zinc-50 text-sm leading-[157%] w-full text-center'>
										{item.step}
									</p>
								</div>
							</SwiperSlide>
						))}
					</Swiper>
				</div>
			</Container>
		</div>
	)
}
